import { createFileRoute } from '@tanstack/react-router';
import { SetupContentStep } from '@/pages/workspaces/transactional/message/setup/content/setup-content-step';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup/',
)({
  component: withRumPageRendered(SetupContentStep),
});
